<template>
    <q-checkbox v-bind="{...$attrs, ...$props}" :model-value="modelValue" @update:model-value="updateEvent"/>
</template>

<script>
import { QCheckbox } from 'quasar';

export default {
    name: 'QCustomCheckbox',
    extends: QCheckbox,
    props: {
        modelValue: {
            type: String,
            default: undefined,
        },
        confirmation: {
            type: [Boolean, String],
            default: false,
        },
    },
    emits: ['update:modelValue'],
    methods: {
        update (v) {
            this.$emit('update:modelValue', v);
        },
        updateEvent (v) {
            if (this.confirmation !== false) {
                this.$q.dialog({
                    title: 'Подтвердите действие',
                    message: typeof this.confirmation === 'string' ? this.confirmation : 'Вы уверены в последствиях?',
                    ok: {
                        label: 'Да',
                    },
                    cancel: {
                        label: 'Нет',
                    },
                }).onOk(() => {
                    this.update(v);
                });
            } else {
                this.update(v);
            }
        },
    },
};
</script>
